module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/main-menu/main-menu.component.scss
// module id = ./src/app/modules/common-module/components/main-menu/main-menu.component.scss
// module chunks = 9